import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './header.css';
import { RiArrowDownSLine } from "react-icons/ri";
import { MdClose } from "react-icons/md";

const menuItems = [
    { name: "home", path: "/", dropdown: [] },
    { name: "about", path: "/about", dropdown: [] },
    { name: "markets", path: "/forex", dropdown: ["forex", "futures", "indices", "stocks", "commodities", "bonds", "options"] },
    { name: "analytics", path: "/news", dropdown: ["news", "technical-analysis", "heatmaps", "watchlists"] },
    { name: "company", path: "/team", dropdown: ["privacy-policy", "team", "faq"] },
];

const MOBILE_GROUPS = [
    { key: 'markets', label: 'markets', links: menuItems[2].dropdown },
    { key: 'analytics', label: 'analytics', links: menuItems[3].dropdown },
    { key: 'company', label: 'company', links: menuItems[4].dropdown },
];

const Header = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [showModal, setShowModal] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [openGroup, setOpenGroup] = useState(null);

    // one listener for the header's lifetime (it used to be re-added on every render)
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY >= 40);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const isActive = (item) =>
        item.path === '/' ? pathname === '/' : [item.path, ...item.dropdown.map(d => `/${d}`)].includes(pathname);

    const closeMenu = () => { setShowModal(false); setOpenGroup(null); };

    return (
        <motion.header className={scrolled ? 'scroll-color' : ''}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.65 }}
        >
            <Link to="/" className="logo-container" aria-label="Ollarin Mirror home">
                <img src="/ollarinmirror-logo.svg" alt="Ollarin Mirror" className="header-logo" />
            </Link>
            <nav>
                <ul>
                    {menuItems.map((item, index) => (
                        <li key={item.name}
                            className="relative"
                            onMouseEnter={() => item.dropdown.length > 0 && setOpenDropdown(index)}
                            onMouseLeave={(e) => {
                                if (!e.relatedTarget || !e.relatedTarget.closest?.(".drop-down-container")) {
                                    setOpenDropdown(null);
                                }
                            }}>
                            <Link to={item.path} className={isActive(item) ? 'active' : ''}>
                                {item.name}
                                {item.dropdown.length > 0 && <RiArrowDownSLine className={`nav-caret${openDropdown === index ? ' open' : ''}`} />}
                            </Link>
                            {openDropdown === index && item.dropdown.length > 0 && (
                                <div className="drop-down-container"
                                    onMouseEnter={() => setOpenDropdown(index)}
                                    onMouseLeave={() => setOpenDropdown(null)}
                                >
                                    <div className="drop-wrapper">
                                        {item.dropdown.map((subItem) => (
                                            <Link key={subItem} to={`/${subItem}`} className="dropdown-link">{subItem.replace('-', ' ')}</Link>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            </nav>
            <div className="sign-up-btn-container">
                <button className='header-signin-btn' onClick={() => navigate('/login')}>Sign in</button>
                <button className='header-cta-btn' onClick={() => navigate('/signup')}>Get started</button>
            </div>
            <button className="mobile-menu-container" onClick={() => setShowModal(!showModal)} aria-label="Open menu" aria-expanded={showModal}>
                <span className="line1"></span>
                <span className="line2"></span>
                <span className="line3"></span>
            </button>
            <div className={`overlay ${showModal ? 'showing-modal' : ''}`} onClick={closeMenu}>
                <button className="overlay-close-btn-container" onClick={closeMenu} aria-label="Close menu">
                    <MdClose />
                </button>
                <div className="menu-card" onClick={(e) => e.stopPropagation()}>
                    <div className="menu-card-image-conatiner">
                        <img src="/ollarinmirror-logo.svg" alt="Ollarin Mirror" className="header-logo" />
                    </div>
                    <ul className="list">
                        <li className="element"><Link to='/' onClick={closeMenu}>home</Link></li>
                        <li className="element"><Link to='/about' onClick={closeMenu}>about</Link></li>
                        {MOBILE_GROUPS.map(group => (
                            <div className="market-dropdown" key={group.key}>
                                <p onClick={() => setOpenGroup(openGroup === group.key ? null : group.key)}>{group.label}</p>
                                <div onClick={() => setOpenGroup(openGroup === group.key ? null : group.key)}
                                    className={`market-dropdown-svg-container ${openGroup === group.key ? 'rotate' : ''}`}>
                                    <RiArrowDownSLine />
                                </div>
                                <div className={`market-links ${openGroup === group.key ? 'show-markets' : ''}`}>
                                    {group.links.map(link => (
                                        <li className="element" key={link}><Link to={`/${link}`} onClick={closeMenu}>{link.replace('-', ' ')}</Link></li>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </ul>
                    <div className="menu-card-actions">
                        <button className='header-signin-btn' onClick={() => { closeMenu(); navigate('/login') }}>Sign in</button>
                        <button className='header-cta-btn' onClick={() => { closeMenu(); navigate('/signup') }}>Get started</button>
                    </div>
                </div>
            </div>
        </motion.header>
    );
};

export default Header;
